import { RelatorioDiretivoModel } from "@/models/administracao/diretivo/RelatorioDiretivoModel";

export interface RequestRelatorioDiretivoDTO {
    inicio?: string;
    fim?: string;
    status?: string;
    avaliacao?: string;
    codigoCliente?: number;
    perfilCliente?: string;
    nomeCliente?: string;
    genero?: string;
    descricaoServico?: string;
    codigoPrestador?: number;
    nomePrestador?: string;
    codigoCorretor?: number;
    nomeCorretor?: string;
    perfil?: string;
}

export class ControllerRelatorioDiretivo {
    public static convertToDTO(model: RelatorioDiretivoModel): RequestRelatorioDiretivoDTO {
        let cliente = Number(model.codigoCliente ?? 0);
        let prestador = Number(model.codigoPrestador ?? 0);
        return {
            inicio: model.dataInicio,
            fim: model.dataFim,
            avaliacao:model.avaliacao,
            codigoCorretor: model.codigoCorretor,
            nomeCorretor: model.nomeCorretor,
            perfilCliente: !!model.perfilCliente?.length ? model.perfilCliente.map(v => v.name).toString() : undefined,
            codigoCliente: cliente,
            nomeCliente: model.nomeCliente?.toString() ?? undefined,
            genero: !!model.genero?.length ? model.genero.map(v => v.name).toString() : undefined,
            descricaoServico: !!model.descricaoServico?.length ? model.descricaoServico.map(v => v.name).toString() : undefined,
            status: !!model.status?.length ? model.status.map(v => v.name).toString() : undefined,
            codigoPrestador: prestador,
            nomePrestador: model.nomePrestador?.toString() ?? undefined,
        };
    }
}